'use client'

import React from 'react'

type Props = {
    mass: number
    radius: number
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 50
const PAD_RIGHT = 12
const PAD_TOP = 14
const PAD_BOTTOM = 28
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM
const G = 6.674e-11

export default function EscapeVelocityChart({ mass, radius }: Props) {
    const rMin = Math.max(radius * 0.3, 1)
    const rMax = Math.max(radius * 3, rMin + 1)
    const vAt = (r: number) => Math.sqrt((2 * G * mass) / r)
    const vMax = Math.max(vAt(rMin), 0.0001)

    const xToSvg = (r: number) => PAD_LEFT + ((r - rMin) / (rMax - rMin)) * PLOT_W
    const yToSvg = (v: number) => PAD_TOP + PLOT_H - (v / vMax) * PLOT_H

    const steps = 40
    const points: string[] = []
    for (let i = 0; i <= steps; i++) {
        const r = rMin + ((rMax - rMin) * i) / steps
        points.push(`${xToSvg(r).toFixed(1)},${yToSvg(vAt(r)).toFixed(1)}`)
    }

    const markerX = xToSvg(Math.min(Math.max(radius, rMin), rMax))
    const markerY = yToSvg(vAt(radius))

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={HEIGHT - PAD_BOTTOM} x2={WIDTH - PAD_RIGHT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <text x={PAD_LEFT} y={HEIGHT - 8} fontSize={10} fill="#6b7280">Radius (m)</text>
            <text x={2} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">Escape v (m/s)</text>
            <polyline points={points.join(' ')} fill="none" stroke="#2563eb" strokeWidth={2} />
            <line x1={markerX} y1={markerY} x2={markerX} y2={HEIGHT - PAD_BOTTOM} stroke="#dc2626" strokeWidth={1} strokeDasharray="3,3" opacity={0.6} />
            <circle cx={markerX} cy={markerY} r={4.5} fill="#dc2626" stroke="#fff" strokeWidth={1.5} />
        </svg>
    )
}
